let _ = t => t,
  _t,
  _t2;
import styled from 'styled-components';
import { fontWeights } from '../styles';
export const Breadcrumbs = styled.ol(_t || (_t = _`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`));
export const Breadcrumb = styled.li(_t2 || (_t2 = _`
    & > .ovpn-breadcrumbs-item-element {
        margin-right: 8px;

        font-weight: ${0};
        text-decoration: none;

        border-bottom: none;

        &:hover:not([aria-disabled]) {
            border-bottom: 1px solid currentColor;
        }
    }
`), fontWeights.medium);